import React, { useEffect, useState } from 'react';
import { axiosGetCall, axiosPostCall } from '../../../services/apisCall';
import Logger from '../../../lib/Logger';
const logger = new Logger("kycListTable");
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import { CustomMenu } from '../../../components/menu/customMenu';

import { PaginationTable } from '../../../components/tables/paginationTable';

import { TableCell, Box, List, ListItem, MenuItem, styled, useTheme, TextField, Button, Typography, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { configFile } from '../../../config';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { Icon } from '@iconify/react';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { ConfirmDialog } from 'src/components/custom-dialog';
import moment from 'moment';
import Iconify from 'src/components/iconify';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import DeleteIcon from '@mui/icons-material/Delete';
import UserFilters from './filters';

const columns = [

  { id: 'num_id', label: 'CLI Id', minWidth: 110, align: 'center' },
  { id: 'cli', label: 'CLI', minWidth: 110, align: 'center' },
  { id: 'cli_type_text', label: 'CLI Type', minWidth: 110, align: 'center' },
  { id: 'gateway_arr', label: 'Assigned Gateway Id', minWidth: 110, align: 'center' },
  { id: 'allowed_user_ids', label: 'Assigned User Id', minWidth: 110, align: 'center' },
  { id: 'create_date', label: 'Create Date', minWidth: 110, align: 'center' },
  { id: 'create_by', label: 'Create By', minWidth: 110, align: 'center' },
  { id: 'expiry_date', label: 'Expiry Date', minWidth: 110, align: 'center' },
  { id: 'status', label: 'Status', minWidth: 110, align: 'center' },
  { id: 'approve_reject_date', label: 'Approve/Reject Date', minWidth: 110, align: 'center' },
  { id: 'actions', label: 'Actions', minWidth: 70, align: 'center' }
];

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  // color: theme.palette.grey[200],
  gap: '8px'
}))
const menuItems = [
  { value: 0, label: 'Inactive', id: '101' },
  { value: 1, label: 'Active', id: '102' },
];

const HeadingSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '12px',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    flexWrap: 'wrap',
  },
}));

export const VoiceCliList = ({ loadit, setUpdateUserId, forceLoad, setReaddCli}) => {
  const theme = useTheme();
  const { URL_MAPPER: { console: consoleUrl } = {} } = configFile
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [rows, setRows] = useState([])
  const [count, setCount] = useState(0)

  const [search, setSearch] = useState("")
  const [load, setLoad] = useState(true)
  const [networkError, setNetworkError] = useState(false)
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const [openAssign, setOpenAssign] = useState(false);
  const [openRemoveAssign, setOpenRemoveAssign] = useState(false);
  const [assign, setAssign] = useState()
  const [validity, setValidity] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [filterLabels, setFilterLabels] = useState([]);
  const [filterData, setFilterData] = useState({
    from: null,
    to: null,
    cli: '',
    assignedUserId: '',
    status: '',
    deletedCli: '',
  });
  const [isFilterApplied, setIsFilterApplied] = useState(false);


  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);



  const handleChange = (value) => setSearch(value)

  const getHostList = async () => {
    const skip = rowsPerPage * page;
    try {
      const params = { skip, limit: rowsPerPage }
      if (search) params.search = search

      const searchArr = [];

      if (filterData.deletedCli !== '' && filterData.deletedCli !== null) {
        searchArr.push({ deletedCli: filterData.deletedCli });
      }

      if (filterData.status !== '' && filterData.status !== null) {
        searchArr.push({ status: filterData.status });
      }

      if (filterData.assignedUserId !== '' && filterData.assignedUserId !== null) {
        searchArr.push({ assignedUserId: filterData.assignedUserId });
      }

      if (filterData.cli) {
        searchArr.push({ cli: filterData.cli });
      }

      if (filterData.from) {
        searchArr.push({ from: filterData.from });
      }

      if (filterData.to) {
        searchArr.push({ to: filterData.to });
      }

      if (searchArr.length > 0) {
        params.searchParams = searchArr;
      }
      console.log("params", params);
      setNetworkError(false)
      const { cliList, totalCliCount } = await axiosGetCall("getVoiceCliList", params)
      setRows(cliList);
      setCount(totalCliCount)
    } catch (error) {
      logger.error("Gateway List", error);
      setNetworkError(true)
      setRows([])
      setCount(0)
      renderErrorMessage(error?.message)
    }
    setLoading(false)
  }

  useEffect(() => {
    // if (load) {
    setLoading(true)
    getHostList()
    setLoad(false)
    forceLoad(false)

    // }
  }, [load, loadit])

  const handleClick = (event, user) => {
    setAnchorEl(event.currentTarget);
    setUserData(user);
  };
  const handleUpdateClick = () => {
    setAnchorEl(null);
    setUpdateUserId(userData.cli);
  };
  const handleReaddCli = () => {
    setAnchorEl(null);
    setReaddCli(userData);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAssignClick = () => {
    setOpenAssign(true);
    setAnchorEl(null);
  }
  const handleRemoveAssignClick = () => {
    setOpenRemoveAssign(true);
    setAnchorEl(null);
  }
  const handleCloseAssign = () => {
    setAnchorEl(null);
    setOpenAssign(false);
    setOpenRemoveAssign(false);
    setAssign();
    setValidity(null);
  }
  const handleDeleteClick = () => {
    setOpenDelete(true);
    setAnchorEl(null);
  };
  const handleCloseDelete = () => {
    setAnchorEl(null);
    setOpenDelete(false);
  };

  const handleConfirmDelete = async () => {
    try {
      const payload = {
        clis: [userData.cli],
        action: "delete",
        gateways: userData.gateway_arr || [],
        cliType: userData.cli_type
      };
      const data = await axiosPostCall('updateVoiceClis', payload);
      renderSuccessMessage(data?.message);
      getHostList();
      setOpenDelete(false);
      setAnchorEl(null);
    } catch (error) {
      logger.error('Gateway List change status', error);
      renderErrorMessage(error?.message);
    }
  };

  const handleConfirmAssign = async (assign) => {
    try {
      if (!assign) {
        renderErrorMessage('User ID is required!');
        return;
      }
      if (!validity) {
        renderErrorMessage('Validity is required!');
        return;
      }
      if (assign && userData.allowed_user_ids?.map(String).includes(assign.trim())) {
        renderErrorMessage('This ID is already assigned!');
        return;
      }
      const payload = {
        assignToUserId: assign.trim(),
        expiryDate: Number(validity),
        action: 'assigned',
        clis: [userData.cli],
      };
      const data = await axiosPostCall('assignRemoveVoiceClisFromUser', payload);
      renderSuccessMessage(data?.message);
      getHostList();
      setOpenAssign(false);
      setAnchorEl(null);
      setAssign();
      setValidity(null);
    } catch (error) {
      logger.error('Gateway List change status', error);
      renderErrorMessage(error?.message);
    }
  };

  const handleConfirmRemoveAssign = async (assign) => {
    try {
      if (!assign) {
        renderErrorMessage('User ID is required!');
        return;
      }
      if (!userData.allowed_user_ids?.map(String).includes(assign.trim())) {
        renderErrorMessage('This ID is not assigned!');
        return;
      }
      const payload = {
        assignToUserId: assign.trim(),
        action: 'removed',
        clis: [userData.cli],
      };
      const data = await axiosPostCall('assignRemoveVoiceClisFromUser', payload);
      renderSuccessMessage(data?.message);
      getHostList();
      setOpenRemoveAssign(false);
      setAnchorEl(null);
      setAssign();
    } catch (error) {
      logger.error('Gateway List change status', error);
      renderErrorMessage(error?.message);
    }
  };

  const resetFilters = () => {
    setFilterLabels([]);
    setSearch('');
    setFilterData({
      from: null,
      to: null,
      cli: '',
      assignedUserId: '',
      status: '',
      deletedCli: '',
    });
    setIsFilterApplied(false);
    setPage(0);
    setLoad(true);
  };

  const apply = (data) => {
    // setRows([]);
    setSearch('');
    setIsFilterApplied(true);

    const hasFilterValue = (value) => {
      if (value === null || value === undefined) return false;
      if (typeof value === 'string') return value.trim() !== '';
      if (Array.isArray(value)) return value.length > 0;
      return true;
    };

    const label = Object.entries(data)
      .filter(([, value]) => hasFilterValue(value))
      .map(([field, value]) => ({ field, key: filterLabelMap[field], value }));

    setFilterLabels(label);

    const newData = JSON.parse(JSON.stringify(data));
    setFilterData(newData);
    setPage(0);
    setLoad(true);
  };

  const generateLabelChipToolTip = (item) => {
    if (['From', 'To'].includes(item?.key)) return moment(item?.value).format('D MMM, YYYY');

    const valueLabelMap = {
      status: {
        0: 'Inactive',
        1: 'Active',
      },
      deletedCli: {
        0: 'No',
        1: 'Yes',
      },
    };

    return valueLabelMap[item?.field]?.[item?.value] ?? item?.value;
  };

  const filterLabelMap = {
    status: 'Status',
    deletedCli: 'Deleted CLI',
    cli: 'CLI',
    assignedUserId: 'Assigned User ID',
    from: 'From',
    to: 'To',
  };

  const reset = () => {
    resetFilters();
  };

  const findForSearchQuery = (search) => {
    setSearch(search);
    if (search?.trim()) {
      setPage(0);
      setLoad(true);
      if (!filterLabels.includes('search')) setFilterLabels([{ key: 'search', value: search }]);
      setIsFilterApplied(false);
      return;
    }
    const updatedLabels = filterLabels.filter((item) => item?.key !== 'search');
    setFilterLabels([...updatedLabels]);
    // setRows([]);
    setIsFilterApplied(false);
    // setPage(0);
    setLoad(true);
  };

  const ActionJsx = (id, align, value, ...other) => {
    const user = other[3]

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.400',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          size: 'small'
        }}>
        <MoreVertIcon
          sx={{ color: 'grey.700', cursor: 'pointer', height: '18px', width: '18px' }}
          aria-controls={open ? 'filters-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={(e) => handleClick(e, user)}
        />
      </TableCell>
    )
  }
  const Content = () => (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    }}>
      <List>
        {userData.cli_type === 2 && userData.isDeleted === 0 && (
          <>
            <ListItem
              sx={{
                display: 'flex',
                gap: '7px',
                fontWeight: 400,
                color: 'grey.700',
                '&:hover': {
                  color: 'grey.800',
                  backgroundColor: 'grey.300',
                  cursor: 'pointer',
                },
              }}
              onClick={handleAssignClick}
            >
              <AssignmentIndIcon sx={{ color: '#1976d2', height: '17px' }} />
              assign to User
            </ListItem>
            <ListItem
              sx={{
                display: 'flex',
                gap: '7px',
                fontWeight: 400,
                color: 'grey.700',
                '&:hover': {
                  color: 'grey.800',
                  backgroundColor: 'grey.300',
                  cursor: 'pointer',
                },
              }}
              onClick={handleRemoveAssignClick}
            >
              <AssignmentIndIcon sx={{ color: '#d32f2f', height: '17px' }} />
              remove assign User
            </ListItem>
          </>
        )}
        {userData.isDeleted === 0 && (
          <ListItem sx={{
            display: 'flex',
            gap: '7px',
            fontWeight: 400,
            color: 'grey.700',
            '&:hover': {
              color: 'grey.800',
              backgroundColor: 'grey.300',
              cursor: "pointer"
            }
          }}
            onClick={handleUpdateClick}
          >
            <Icon icon="lucide:edit" style={{ color: '#1976d2', height: '17px', margin: '5px' }} />
            Update
          </ListItem>
        )}
        {userData.isDeleted === 0 && (

          <ListItem
            sx={{
              display: 'flex',
              gap: '7px',
              fontWeight: 400,
              color: 'grey.700',
              '&:hover': {
                color: 'grey.800',
                backgroundColor: 'grey.300',
                cursor: 'pointer',
              },
            }}
            onClick={handleDeleteClick}
          >
            <DeleteIcon sx={{ color: '#d32f2f', height: '17px' }} />
            Delete CLI
          </ListItem>
        )}
        {userData.isDeleted === 1 && (
          <ListItem sx={{
            display: 'flex',
            gap: '7px',
            fontWeight: 400,
            color: 'grey.700',
            '&:hover': {
              color: 'grey.800',
              backgroundColor: 'grey.300',
              cursor: "pointer"
            }
          }}
            onClick={handleReaddCli}
          >
            <Icon icon="lucide:edit" style={{ color: '#1976d2', height: '17px', margin: '5px' }} />
            Readd the CLI
          </ListItem>
        )}
      </List>
    </Box>
  )

  const statusjsx = (id, align, value, userId, status, documentApprovedStatus, row) => {
    let label = '';
    let boxStyles = {};

    if (value === 0 && row?.isDeleted === 0) {
      label = 'Inactive';
      boxStyles = {
        color: '#D19244',
        backgroundColor: 'rgba(209, 146, 68, 0.20)',
      };
    } else if (value === 1 && row?.isDeleted === 0) {
      label = 'Active';
      boxStyles = {
        color: '#50AB64',
        backgroundColor: 'rgba(40, 167, 69, 0.20)',
      };
    } else if (row?.isDeleted === 1) {
      {
      label = 'Deleted';
      boxStyles = {
        color: '#E2533F',
        backgroundColor: 'rgba(236, 64, 64, 0.20)',
      };
    }
  }

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          background: 'transparent',
        }}
      >
        <Box
          sx={{
            borderRadius: '6px',
            fontWeight: 600,
            fontSize: '14px',
            display: 'inline-block',
            ...boxStyles,
            px: '12px',
            py: '2px',
          }}
        >
          {label}
        </Box>
      </TableCell>
    );
  };
  const allowedUserIds = (id, align, value, row) => {
    const tooltipText =
      Array.isArray(value) && value.length > 0
        ? value.join(", ")
        : "No User IDs assigned";

    const label =
      Array.isArray(value) && value.length > 0 ? <InfoIcon /> : "-";

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          borderBottom: "0.5px dashed",
          borderColor: "grey.300",
          background: "transparent",
        }}
      >
        {row.cli_type === 2 ?
          <Tooltip title={tooltipText} arrow>
            <span>{label}</span>
          </Tooltip>
          : '-'}
      </TableCell>
    );
  };
  const gatewayArray = (id, align, value) => {
    const tooltipText =
      Array.isArray(value) && value.length > 0
        ? value.join(", ")
        : "No Gateway IDs assigned";

    const label =
      Array.isArray(value) && value.length > 0 ? <InfoIcon /> : "-";

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          borderBottom: "0.5px dashed",
          borderColor: "grey.300",
          background: "transparent",
        }}
      >
        <Tooltip title={tooltipText} arrow>
          <span>{label}</span>
        </Tooltip>
      </TableCell>
    );
  };
  const createdatejsx = (id, align, value) => {
    const date = moment(Number(value) * 1000); // Convert Unix timestamp to milliseconds
    const formattedDate = date.format('D MMM, YYYY');
    const formattedTime = date.format('h:mm A');
    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}>
        <>
          <Box>{value !== '' && value !== undefined && value !== null ? `${formattedDate} ${formattedTime}` : '-'}</Box>
        </>
      </TableCell>
    );
  };
  const routeJsx = (id, align, value) => {
    const ROUTE_LABELS = {
      transactional: "Transactional",
      promotional: "Promotional",
      explicit: "Explicit",
      implicit: "Implicit"
    };
    const label = ROUTE_LABELS[value] || value;

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          background: 'transparent',
        }}
      >
        {label}
      </TableCell>
    );
  };

  const passwordjsx = (id, align, value) => {
    const handleClick = () => {
      navigator.clipboard.writeText(value);
      renderSuccessMessage("Password copied to clipboard!");
    };

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        <Iconify
          icon="prime:copy"
          width="20px"
          color={theme.palette.primary.main}
        />
      </TableCell>
    );
  };

  const tableFilter = (
    <HeadingSection>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '10px',
          alignItems: 'center',
        }}
      >
        {/* <HeadingTypography>Customers</HeadingTypography> */}

        {!!filterLabels.length && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '6px',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            {filterLabels.map((item) => (
              <Tooltip key={item?.field} title={generateLabelChipToolTip(item)}>
                <Chip label={item?.key} variant="outlined" size="small" />
              </Tooltip>
            ))}

            <Button variant="outlined" size="small" color="warning" onClick={() => resetFilters()}>
              Clear Filter
            </Button>
          </Box>
        )}
      </Box>

      <UserFilters
        findForSearchQuery={findForSearchQuery}
        // getPlansList={refetch}
        apply={apply}
        reset={reset}
        search={search}
        isFilterApplied={isFilterApplied}
        filterData={filterData}
        setFilterData={setFilterData}
      />
    </HeadingSection>
  );


  const ActionModals = () => {
    return (
      <CustomMenu
        anchorEl={anchorEl}
        handleClose={handleClose}
        Content={Content}
      />
    )
  }
  return (
    <>
      <PaginationTable
        page={page}
        tableFilter={tableFilter}
        ActionJsx={ActionJsx}
        ActionModals={ActionModals}
        setLoad={setLoad}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        count={count}
        error={networkError}
        loading={loading}
        setLoading={setLoading}
        rows={rows}
        columns={columns}
        handleChange={handleChange}
        search={search}
        calculatedHeight={288}
        status={statusjsx}
        allowedUserIdsJsx={allowedUserIds}
        gatewayArrayJsx={gatewayArray}
        routeJsx={routeJsx}
        createdatejsx={createdatejsx}
        passwordjsx={passwordjsx}
      />
      <ConfirmDialog
        open={openAssign}
        onClose={handleCloseAssign}
        title="Assign CLI to User"
        content={
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px"
          }}
          >
            Assign CLI: {userData.cli}
            <Box sx={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              alignItems: "center"
            }}
            >
              <Typography >User ID</Typography>
              <TextField
                required
                id="outlined-required"
                label="User ID"
                multiline
                maxRows={4}
                fullWidth
                value={assign}
                onChange={(e) => setAssign(e.target.value)}
                sx={{ marginTop: "10px" }}
              />
            </Box>
            <Box sx={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              alignItems: "center"
            }}
            >
              <Typography >Validity</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Validity"
                  value={validity ? dayjs.unix(validity) : null}
                  onChange={(newValue) =>
                    setValidity(newValue ? newValue.startOf("day").unix() : null)
                  }
                  shouldDisableDate={(date) =>
                    dayjs(date).isBefore(dayjs().startOf("day"))
                  }
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: {
                        width: "180px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Box>
        }
        action={
          <Button
            color="secondary"
            variant="contained"
            sx={{
              color: '#fff',
              height: '30px',
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.main',
              },
              boxShadow: "none",
              marginRight: '10px'
            }}
            onClick={() => handleConfirmAssign(assign)}
          >Confirm
          </Button>
        }
      />
      <ConfirmDialog
        open={openRemoveAssign}
        onClose={handleCloseAssign}
        title="Remove Assign CLI"
        content={
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px"
          }}
          >
            Remove Assign CLI: {userData.cli}
            <Box sx={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              alignItems: "center"
            }}
            >
              <Typography>User ID</Typography>
              <TextField
                required
                id="outlined-required-remove"
                label="User ID"
                multiline
                maxRows={4}
                fullWidth
                value={assign}
                onChange={(e) => setAssign(e.target.value)}
                sx={{ marginTop: "10px" }}
              />
            </Box>
          </Box>
        }
        action={
          <Button
            color="secondary"
            variant="contained"
            sx={{
              color: '#fff',
              height: '30px',
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.main',
              },
              boxShadow: "none",
              marginRight: '10px'
            }}
            onClick={() => handleConfirmRemoveAssign(assign)}
          >Confirm
          </Button>
        }
      />
      <ConfirmDialog
        open={openDelete}
        onClose={handleCloseDelete}
        title="Delete CLI"
        content={
          <span>
            Are you sure you want to delete this CLI {userData.cli}?

          </span>
        }
        action={
          <Button
            color="secondary"
            variant="contained"
            sx={{
              color: '#fff',
              height: '30px',
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.main',
              },
              boxShadow: "none",
              marginRight: '10px'
            }}
            onClick={() => handleConfirmDelete()}
          >Confirm
          </Button>
        }
      />
    </>
  )
}
